import React from 'react';
import { KebabMenu, KebabOption } from '../kebab-menu/kebab-menu';
import { SVGS } from '../../assets';
import { useFieldOpsUploadSummaryScreen } from '../../contexts';

export const MessageKebabMenu = () => {
  const { openChangeIntentModal, openDeleteModal, openSelectCustomerModal } =
    useFieldOpsUploadSummaryScreen();
  const options: KebabOption[] = [
    {
      type: 'item',
      label: 'Move to Customer',
      icon: SVGS.MoveIcon,
      onClick: openSelectCustomerModal,
    },
    {
      type: 'item',
      label: 'Change Intent',
      icon: SVGS.PencilIcon,
      onClick: openChangeIntentModal,
    },
    { type: 'divider' },
    {
      type: 'item',
      label: 'Delete',
      icon: SVGS.DeleteIcon,
      onClick: openDeleteModal,
      className: 'danger',
    },
  ];

  return <KebabMenu options={options} />;
};
